

//tab
function openTab(tabName) {
   console.log(tabName)
  let i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");//コンテンツのDOM取得
  //全コンテンツを一度見えなくする
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tw-tab");//ボタンのDOM取得
  //全タブのボタンのフォーカスを除去する

  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" tw-tab-active", "");
  }
  document.getElementById(tabName).style.display = "block";//選択されたIDを持つコンテンツを表示
  event.currentTarget.className += " tw-tab-active";//選択されたボタンにactiveクラスを付与する

}

//flickityスライダー
$(function(){

  //閲覧履歴、お気に入り一覧など
  $('.my-flickity-slider').flickity(
    { "groupCells": true, "pageDots": false, "contain": true, "cellAlign": "left" }

  );

  //トップページ、カバースライドショー（1つのカルーセルでSP/PC対応）
  var $cover = $('.cover-carousel-single');
  var $coverWrapper = $('[data-cover-carousel-wrapper]');
  if ($cover.length && !$cover.hasClass('flickity-enabled')) {
    $cover.on('ready.flickity', function() {
      $coverWrapper.removeClass('cover-carousel-loading');
    });
    $cover.flickity({ freeScroll: false, wrapAround: true, autoPlay: true });
    setTimeout(function() {
      $coverWrapper.removeClass('cover-carousel-loading');
    }, 500);
  }

});

//register.liquid

function checkValue(){
  let element1 = document.getElementById('checkbox-privacy_policy');
  let element2 = document.getElementById('checkbox-customer_term');
  let btn = document.getElementById('btn-submit');


  if(element1.checked && element2.checked){
    
    btn.removeAttribute("disabled");

  }else{
    btn.setAttribute("disabled", true)
  }

}

/*
$(function(){
  //フォーム指定
  $('#create_customer').validate({

    rules: {
      test: {
        required: true
      }
    },

    //エラーメッセージ設定
    messages: {
      test: {
        required: '必須項目です'
      }
    },
    invalidHandler: function(form, validator) {
      alert("!!!")
      return false;
    }
  });

  $("#register_last_name").blur(function(){
    console.log("blur")
    $("#create_customer").valid();
  });
  

});

*/

$(function () {
  $(".qanda .contens_main").click(function () {
    $(this).find(".qa-btn").fadeToggle(100);
    // $(this).siblings(".qa-btn").fadeToggle(100);
    $(this).find(".qa-content").slideToggle(100);
  });
});



const getCookie = (cookie_name)=>{
    
  //Cookieを取得する
  saved_cookies = Cookies.get(cookie_name)
  console.log(saved_cookies)

  if(saved_cookies != null || saved_cookies != undefined){
    //Cookie(json)を配列に分割して返す
    if(saved_cookies){
      result = JSON.parse(saved_cookies); 
    }
    
  }else{
    result = new Array
  }
 
  return result;
}
 

//配列かjsonを渡してcookieに書き込む
const setCookie = (cookie_name, json_str)=>{
  let cookie = '';
  let expire = '';
  let period = '';

/*
  if( name == "bookmark"){
  //idが重複しているものを取り除く
    var newArray = array.filter(
      (element, index, self) => self.findIndex((e) => e.id === element.id) === index
    );
      //Cookieの保存名と値を指定。Jsonにして保存
      // cookies = name + '=' + JSON.stringify(newArray) + ';';
  }else{
    //queryが重複しているものを取り除く
    var newArray = array.filter(
      (element, index, self) => self.findIndex((e) => e.query === element.query) === index
    );
    // //件数を最新10件に調整
    newArray = newArray.slice( 0, 10 )
   
  }
*/

// 'value'



    //キーワードをjsonに
    // const json = {
    //     query: word
    // };


    //クッキーをセットする
    Cookies.set(cookie_name, json_str,{ expires: 90 });

    // // ユーザーの使用言語を日本語に指定
    Cookies.set('locale', 'ja-JP'); 

    // if(cookies != null){ 

    //     //Cookie(json)を配列に分割して返す
    //     if(cookies){
    //       result = JSON.parse(cookies); 
    //     }
        
    //   }else{
    //     result = new Array
    //   }

//   return false

//   cookies = name + '=' + JSON.stringify(newArray) + ';';

//   console.log(cookies);

// const json = {
//     query: keyword
//   };

  //Cookieを保存するパスを指定
//   cookies += 'path=/ ;';

//   //Cookieを保存する期間を指定
//   period = 30; //保存日数
//   expire = new Date();
//   expire.setTime(expire.getTime() + 1000 * 3600 * 24 * period);
//   expire.toUTCString();
//   cookies += 'expires=' + expire + ';';

//   //Cookieを保存する
//   document.cookie = cookies;
};




$(function () {

  //検索履歴をクッキーから読み込んで表示する
  $('.live-search-form-field').focus(function () {

    // console.log("focus")

    let search_historyArray = getCookie("search_history");
    //重複を除く
    search_historyArray = search_historyArray.filter(
        (element, index, self) => self.findIndex((e) => e.query === element.query) === index
      );
    //10件取り出す
    search_historyArray = search_historyArray.slice(0,10);


    console.log(search_historyArray)

    const target = "#live-search-more-keyword";

    $("#live-search-more").slideDown(100);

    let template = `<li class="tw-my-2"><a href="/search?q=[keyword]&type=product">[keyword]</a></li>`
    let str = "";
    $(target).html("");

    search_historyArray.forEach(function(object) {
    //   console.log(object.query)
      const keyword = object.query;
      if(keyword != undefined){
        str = str + template.replace('[keyword]',keyword)
        .replace('[keyword]',keyword)
        }
    });

    $(target).append(str)
  
  });

 
  $('#live-search-more').mouseover(function () {
    $('.live-search-form-field').blur()
  
  });


  // $('.live-search-form-field').blur(function () {
  //   $("#live-search-more").slideUp(1000);
  //   // $("#live-search-more-keyword").html("");
  
  // });

  $('#site-main,footer').click(function () {
    $("#live-search-more").slideUp(100);
    // $("#live-search-more-keyword").html("");
  
  });


/*書き込み */
$('.live-search-form, .productgrid--search-form').submit(function () {
    let keyword = ($(this).find('input[name="q"]').val())
    
    // console.log(keyword)

    //



    //保存されていたcookieを取得
    // const savedArray = getCookie("search_history");
    //保存されていたcookieに新しい内容を追加
    // const newArrey = savedArray.concat()
    // newArrey.unshift(json)

    //

    // console.log(keyword)

    // search_history_Array = getCookie('search_history');

    // const newArrey = search_history_Array.concat()
    // newArrey.unshift(keyword)

    const json = {
        query: keyword
    };

    //jsonを文字列に
    let json_str =  JSON.stringify(json);

    //cookieの読み込み
    let saved_cookies = Cookies.get("search_history");

    //cookiがあれば、読み込む。先頭と末尾の[]を削除。新しいjson文字列と連結
    if(saved_cookies != undefined){
        saved_cookies = saved_cookies.replace('[',"")
        .replace(']',"")
        json_str =  json_str + "," + saved_cookies
    }

    //文字列にブラケットを付与
    json_str = "[" + json_str + "]"


    if(keyword !=""){
    //   setCookie('search_history', newArrey);
      setCookie('search_history', json_str);
    }

  });


  $(".add_bookmark").click(function () {

    const json = {
      id: $(this).data('id'),
      handle: $(this).data('handle'),
      published_at: $(this).data('published_at'),
      title: $(this).data('title'),
      image: $(this).data('image')
    };


    //jsonを文字列に
    let json_str =  JSON.stringify(json);

    //cookieの読み込み
    let saved_cookies = Cookies.get("bookmark");

    //cookiがあれば、読み込む。先頭と末尾の[]を削除。新しいjson文字列と連結
    if(saved_cookies != undefined){
        saved_cookies = saved_cookies.replace('[',"")
        .replace(']',"")
        json_str =  json_str + "," + saved_cookies
    }

    //文字列にブラケットを付与
    json_str = "[" + json_str + "]"


    setCookie('bookmark', json_str);
  });

  

  $('body').on('click', '.delete_bookmark' , function() {

    console.log("delete");

    const delete_id = $(this).data('id');

    //cookieの読み込み
    const saved_cookiesArray = getCookie("bookmark");

    //delete_idの入った要素を除いた配列を作成
    let filteredArray = saved_cookiesArray.filter(o => o.id !== delete_id);

    console.log(filteredArray);

    //配列の要素数で処理を分ける
    if(filteredArray.length !=0 ){

        //jsonを文字列に
        let json_str =  JSON.stringify(filteredArray);

        json_str = json_str.replace('[',"")
        .replace(']',"");

        //文字列にブラケットを付与
        if(json_str != ""){
            json_str = "[" + json_str + "]"
        }
        
        //cookie名と調整済みの配列を渡す
        setCookie('bookmark', json_str);


    }else{
        Cookies.remove('bookmark')//０ならクッキーを削除
    }

    $('.tw-swap').removeClass('tw-swap-active');
    
    // //ブックマークのHTMLを削除
    $(this).parents(".article--excerpt-wrapper").fadeOut(100);

  });

  //ブックマークされている記事かどうかを判別
  const checkBookmarks = ()=>{

    const this_id = $('.add_bookmark').data('id');
    const savedArray = getCookie("bookmark");
    

    var index = savedArray.findIndex(e => e.id === this_id);
    if (index !== -1) {
      console.log("bookmarked");
      // $('.tw-swap').addClass('tw-swap-active');
      $('.tw-swap > input[type=checkbox]').attr('checked', true).prop('checked', true).change()
    }
  }
  


  const showBookmarks = ()=>{

    const bookmarkArray = getCookie('bookmark')

    console.log(bookmarkArray)

    if(!(bookmarkArray.length)){
     
      $("#message").append("登録された記事はありません")
      return false;
    }


    let str = "";
    const kugiri = " + "

    let template = `<li class="article--excerpt-wrapper pxu-lia-block pxu-lia-block--play">
    <article class="article-list-item tw-relative">
    <div data-id="[id]" class="delete_bookmark tw-cursor-pointer tw-absolute tw-bg-gray-200 tw-z-10 tw-block tw-w-[24px] tw-h-[24px] tw-leading-[24px] tw-top-1 tw-right-1 tw-rounded-[50%]"><div class="tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-h-[24px]"><img src="https://oisland.myshopify.com/cdn/shop/t/7/assets/icon-close.png" alt="close" class="tw-w-2 tw-block"></div></div>
   
        <a class="article--excerpt-image tw-container" href="[handle]">
            <img src="[image]" data-rimg="loaded">
        </a>
      
        <div class="article--excerpt-content pxu-lia-element" style="--pxu-lia-inner-sequence: 0; animation-play-state: running;">
            <div class="article--excerpt-meta">
                <span class="article--excerpt-meta-item">
                [published_at]
                </span>
            </div>
            <h2 class="article--excerpt-title">
                <a href="[handle]">
                    [title]
                </a>
            </h2>
        </div>
    </article>
</li>`



    bookmarkArray.forEach(function(bookmark) {

      str = str + template.replace('[title]',bookmark.title)
      .replace('[id]',bookmark.id)
      .replace('[handle]',bookmark.handle)
      .replace('[handle]',bookmark.handle)
      .replace('[published_at]',bookmark.published_at)
      .replace('[image]',bookmark.image)
      
    });

    $("#bookmark__wrapper").append(str)

  }


  if($('#bookmark__wrapper').length){
    showBookmarks();
  }

 if($('.is-bookmark').length){
    checkBookmarks();
  }
  
});

$(function () {
  $("#thanks-login-oiskun").fadeIn(300);
});




$(function () {
  //郵便番号欄にフォーカスされた時点で、市町村とアドレス1のラベルを小さくする
  $("#customer_addr_new_zip").focus(function () {
    $('#customer_addr_new_city,#customer_addr_new_address1').addClass("form-field-filled");

  });

});

// 商品カテゴリ・シーンフィルターを初期表示で展開（FilterGroupsのcloseAll後に再オープン）
function openCategoryFilterExpanded() {
  var selectors = ['.filter-label-商品カテゴリ', '.filter-label-シーン'];
  selectors.forEach(function (sel) {
    var btn = document.querySelector(sel + ' [data-filter-group-trigger]');
    if (btn && btn.getAttribute('aria-expanded') === 'false') {
      btn.click();
    }
  });
}
function scheduleOpenCategoryFilter() {
  setTimeout(openCategoryFilterExpanded, 300);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleOpenCategoryFilter);
} else {
  scheduleOpenCategoryFilter();
}
document.addEventListener('shopify:section:load', scheduleOpenCategoryFilter);

// Product recommendations slider indicator (Figma node: 928-1503)
(function () {
  function getSelectedIndexFromDom(row) {
    var items = row.querySelectorAll('.productgrid--item');
    if (!items.length) return 0;
    var selected = row.querySelector('.productgrid--item.is-selected');
    if (!selected) return 0;
    return Array.prototype.indexOf.call(items, selected);
  }

  function updateDots(indicator, selectedIndex) {
    var dots = indicator.querySelectorAll('.product-recommendations__indicator-dot');
    dots.forEach(function (dot, index) {
      if (index === selectedIndex) {
        dot.classList.add('is-selected');
      } else {
        dot.classList.remove('is-selected');
      }
    });
  }

  function buildDots(indicator, count, selectedIndex) {
    indicator.innerHTML = '';
    for (var i = 0; i < count; i += 1) {
      var dot = document.createElement('span');
      dot.className = 'product-recommendations__indicator-dot';
      if (i === selectedIndex) dot.classList.add('is-selected');
      indicator.appendChild(dot);
    }
    indicator.classList.add('is-active');
  }

  function attachIndicator(section) {
    if (!section) return;
    var row = section.querySelector('[data-product-row]');
    var indicator = section.querySelector('[data-recommendations-indicator]');
    if (!row || !indicator) return;

    var itemCount = row.querySelectorAll('.productgrid--item').length;
    if (itemCount <= 1) {
      indicator.classList.remove('is-active');
      indicator.innerHTML = '';
      return;
    }
    var flickity = row.flickity || (window.Flickity && window.Flickity.data ? window.Flickity.data(row) : null);
    var selected = flickity && typeof flickity.selectedIndex === 'number'
      ? flickity.selectedIndex
      : getSelectedIndexFromDom(row);
    var currentDots = indicator.querySelectorAll('.product-recommendations__indicator-dot').length;
    if (currentDots !== itemCount) {
      buildDots(indicator, itemCount, selected);
    } else {
      indicator.classList.add('is-active');
      updateDots(indicator, selected);
    }

    if (indicator.dataset.boundToDom === '1') return;
    indicator.dataset.boundToDom = '1';

    var observer = new MutationObserver(function () {
      var count = row.querySelectorAll('.productgrid--item').length;
      if (count <= 1) {
        indicator.classList.remove('is-active');
        indicator.innerHTML = '';
        return;
      }
      var domSelected = getSelectedIndexFromDom(row);
      var dotCount = indicator.querySelectorAll('.product-recommendations__indicator-dot').length;
      if (dotCount !== count) {
        buildDots(indicator, count, domSelected);
      } else {
        updateDots(indicator, domSelected);
      }
    });
    observer.observe(row, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    if (flickity) {
      flickity.on('select', function () {
        updateDots(indicator, flickity.selectedIndex || 0);
      });
      flickity.on('cellChange', function () {
        var count = row.querySelectorAll('.productgrid--item').length;
        buildDots(indicator, count, flickity.selectedIndex || 0);
      });
    }
  }

  function initRecommendationIndicators() {
    var sections = document.querySelectorAll('[data-product-recommendations]');
    sections.forEach(function (section) {
      // Product recommendations are rendered asynchronously, so poll briefly.
      var attempts = 0;
      var maxAttempts = 20;
      var timer = window.setInterval(function () {
        attempts += 1;
        attachIndicator(section);
        var indicatorReady = !!section.querySelector('.product-recommendations__indicator.is-active');
        if (indicatorReady || attempts >= maxAttempts) {
          window.clearInterval(timer);
        }
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendationIndicators);
  } else {
    initRecommendationIndicators();
  }
  document.addEventListener('shopify:section:load', initRecommendationIndicators);
})();
